import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";

const StoreCtx = createContext(null);
const load = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [cart, setCart] = useState(() => load("gmc_cart", []));
  const [currency, setCurrency] = useState(() => load("gmc_cur", "BRL"));
  const [cartOpen, setCartOpen] = useState(false);

  const refreshSettings = useCallback(() => http.get("/store").then((r) => setSettings(r.data)), []);
  useEffect(() => { refreshSettings(); }, [refreshSettings]);
  useEffect(() => { localStorage.setItem("gmc_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("gmc_cur", JSON.stringify(currency)); }, [currency]);
  useEffect(() => { if (settings?.store_name) document.title = settings.store_name; }, [settings]);

  const add = (p, qty = 1) =>
    setCart((c) => {
      const ex = c.find((i) => i.id === p.id);
      if (ex) return c.map((i) => (i.id === p.id ? { ...i, quantity: Math.min(99, i.quantity + qty) } : i));
      return [...c, { id: p.id, name: p.name, image: p.image, price_brl: p.price_brl, price_eur: p.price_eur, quantity: qty }];
    });
  const setQty = (id, q) => setCart((c) => (q < 1 ? c.filter((i) => i.id !== id) : c.map((i) => (i.id === id ? { ...i, quantity: q } : i))));
  const clear = () => setCart([]);
  const priceOf = (p, cur = currency) => (cur === "BRL" ? p.price_brl : p.price_eur);
  const total = (cur = currency) => cart.reduce((s, i) => s + priceOf(i, cur) * i.quantity, 0);
  const count = cart.reduce((s, i) => s + i.quantity, 0);

  return (
    <StoreCtx.Provider value={{ settings, refreshSettings, cart, add, setQty, clear, total, count, priceOf, currency, setCurrency, cartOpen, setCartOpen }}>
      {children}
    </StoreCtx.Provider>
  );
};

export const useStore = () => useContext(StoreCtx);
